// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ClassSpreadSheet_wrapper__3BLUJ","action":"ClassSpreadSheet_action__3MKZ0","note":"ClassSpreadSheet_note__1rwh-"};